import createNamespaceContext from './helper/createNamespaceContext';
export var NAVIGATION_CONTEXT = 'navigationCtx';
export var NavigationAnalyticsContext = createNamespaceContext(NAVIGATION_CONTEXT, 'NavigationAnalyticsContext');
//# sourceMappingURL=NavigationAnalyticsContext.js.map